import { Link } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import Skeleton from "react-loading-skeleton";
import { JSX } from "react";
import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import ForwardMailIcon from "../../../common/images/forward-mail.svg?react";
import { useEmployeeDetailHeader } from "../hooks/useEmployeeDetailHeader";

export const EmployeeDetailHeader = (): JSX.Element | null => {
    const {
        isLoading: employeeDataIsLoading,
        employeeId,
        hasEmployeeData,
        name,
        statusName,
        statusColorCode,
        establishmentName,
        hasFunctionGroups,
        functionGroupLabel,
        canResend,
        isResending,
        onResend,
    } = useEmployeeDetailHeader();

    if (employeeDataIsLoading) {
        return (
            <Skeleton
                height={"5rem"}
                count={2}
                borderRadius={"1.5rem"}
                style={{ marginBottom: "3rem" }}
            />
        );
    }
    if (!employeeId || !hasEmployeeData) {
        return null;
    }

    return (
        <header className="p-employee-detail__header">
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /
                    Vestigingen / {establishmentName} /{" "}
                    <Link to={RouteEnum.EMPLOYEES}>Medewerkers</Link> /{" "}
                    <Link to={`${RouteEnum.EMPLOYEES}/${employeeId}`}>
                        {name}
                    </Link>
                </span>
            </div>
            <div className={"p-employee-detail__header--flex"}>
                <div className={"p-employee-detail__header--left"}>
                    <div className={"p-employee-detail__header__title"}>
                        <h2>{name}</h2>
                        <span
                            className={
                                "p-employee-detail__header__title__status p-employee-detail__header__title__status--" +
                                statusColorCode
                            }
                        >
                            {statusName}
                        </span>
                    </div>

                    {hasFunctionGroups && (
                        <p>
                            {functionGroupLabel} bij {establishmentName}
                        </p>
                    )}
                </div>
                {canResend && (
                    <div className={"p-employee-detail__header--right"}>
                        <Button
                            loading={isResending}
                            onClick={onResend}
                            variant={"primary"}
                        >
                            <ForwardMailIcon /> Opnieuw uitnodigen
                        </Button>
                    </div>
                )}
            </div>
        </header>
    );
};
